// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ATBh","tabsBox":"styles_tabsBox__3CXR1","createButton":"styles_createButton__3XsF_"};